(() => {
  const init = (root) => {
    if (root.dataset.saeReady) return;
    root.dataset.saeReady = 'true';
    const trigger = root.querySelector('summary');
    const surface = root.querySelector('.sae-mega__surface');
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    panels.forEach((panel) => {
      panel.querySelectorAll('.sae-mega__sub').forEach((sub) => { sub.hidden = true; });
      panel.querySelectorAll('.sae-mega__reset').forEach((button) => button.addEventListener('click', () => {
        panel.querySelector('.sae-mega__recommended').hidden = false;
        panel.querySelectorAll('.sae-mega__sub').forEach((sub) => { sub.hidden = true; });
        panel.querySelectorAll('.sae-mega__shortcut').forEach((link) => link.removeAttribute('aria-current'));
        panel.scrollTop = 0;
        panel.focus();
      }));
    });
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    let timer;
    let hoverOpened = false;
    const position = () => {
      const nav = root.closest('nav');
      root.style.setProperty('--sae-mega-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
    };
    const activate = (tab, focus = false) => {
      tabs.forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
      });
      panels.forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      if (focus) tab.focus();
    };
    const close = (focus = false) => {
      clearTimeout(timer);
      root.open = false;
      if (focus) trigger.focus();
    };
    const open = () => {
      clearTimeout(timer);
      document.querySelectorAll('[data-sae-mega][open]').forEach((el) => { if (el !== root) el.open = false; });
      position();
      root.open = true;
    };
    trigger.addEventListener('pointerenter', () => { if (fine.matches && !root.open) { open(); hoverOpened = true; } });
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (hoverOpened) { hoverOpened = false; open(); }
      else if (root.open) close();
      else open();
    });
    root.addEventListener('pointerenter', () => clearTimeout(timer));
    root.addEventListener('pointerleave', () => {
      if (fine.matches && !root.contains(document.activeElement)) timer = setTimeout(() => close(), 250);
    });
    root.addEventListener('toggle', () => {
      if (root.open) position();
      trigger.setAttribute('aria-expanded', String(root.open));
    });
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('pointerenter', () => { if (fine.matches) activate(tab); });
      tab.addEventListener('keydown', (e) => {
        let next;
        const at = tabs.indexOf(tab);
        if (e.key === 'ArrowDown') next = (at + 1) % tabs.length;
        if (e.key === 'ArrowUp') next = (at + tabs.length - 1) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { e.preventDefault(); activate(tabs[next], true); }
      });
    });
    root.querySelectorAll('.sae-mega__shortcut').forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = document.getElementById(link.getAttribute('href').slice(1));
        const panel = link.closest('[role="tabpanel"]');
        if (!target || !panel) return;
        e.preventDefault();
        panel.querySelector('.sae-mega__recommended').hidden = true;
        panel.querySelectorAll('.sae-mega__sub').forEach((sub) => { sub.hidden = sub !== target; });
        panel.querySelectorAll('.sae-mega__shortcut').forEach((shortcut) => {
          if (shortcut === link) shortcut.setAttribute('aria-current', 'true');
          else shortcut.removeAttribute('aria-current');
        });
        panel.scrollTo({ top: panel.scrollTop + target.getBoundingClientRect().top - panel.getBoundingClientRect().top - 15, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
    root.querySelector('[data-sae-mega-close]').addEventListener('click', () => close(true));
    root.querySelector('[data-sae-mega-shade]').addEventListener('click', () => close(true));
    document.addEventListener('click', (e) => { if (root.open && !root.contains(e.target)) close(); });
    document.addEventListener('keydown', (e) => {
      if (root.open && e.key === 'Escape') { e.preventDefault(); close(true); }
    });
    root.addEventListener('focusout', () => {
      setTimeout(() => { if (root.open && !root.contains(document.activeElement)) close(); }, 0);
    });
    window.addEventListener('resize', () => { if (root.open) position(); });
    window.addEventListener('scroll', () => { if (root.open) position(); }, { passive: true });
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', surface.id = 'mega-surface-' + root.closest('[id]').id);
  };
  document.querySelectorAll('[data-sae-mega]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-sae-mega]').forEach(init));
})();
